import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./sections/HeroSection";
import TruthSection from "./sections/TruthSection";
import AboutTeaserSection from "./sections/AboutTeaserSection";
import CoachingSuiteSection from "./sections/CoachingSuiteSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import CredentialsTrainingSection from "./sections/CredentialsTrainingSection";
import PressSection from "@/components/feature/PressSection";
import ShopTeaserSection from "./sections/ShopTeaserSection";
import ConferenceSection from "./sections/ConferenceSection";
import EmailCaptureSection from "./sections/EmailCaptureSection";
import FinalCtaSection from "./sections/FinalCtaSection";

const SectionDivider = () => (
  <div className="w-full h-px bg-accent-500/30" />
);

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <SectionDivider />
        <TruthSection />
        <SectionDivider />
        <AboutTeaserSection />
        <SectionDivider />
        <CoachingSuiteSection />
        <SectionDivider />
        <TestimonialsSection />
        <SectionDivider />
        <CredentialsTrainingSection />
        <SectionDivider />
        <PressSection variant="credentials" />
        <SectionDivider />
        <ShopTeaserSection />
        <SectionDivider />
        <ConferenceSection />
        <SectionDivider />
        <EmailCaptureSection />
        <SectionDivider />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
}